/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.jdgm-all-reviews-text');

    if (!trigger) return;

    e.preventDefault();

    const target = document.getElementById('judgeme_product_reviews');

    if (!target) return;

    const offset = 100;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
  });


  (function () {
    const selector = '[data-add-to-cart-text][data-custom-button-text]';

    function applyCustomButtonText(container, variant) {
      const scope = container || document;

      scope.querySelectorAll(selector).forEach((el) => {
        const customText = el.getAttribute('data-custom-button-text');
        const button = el.closest('[data-add-to-cart]');

        if (customText) {
          if (variant) {
            if (variant.available) el.textContent = customText;
          } else if (!button || !button.disabled) {
            el.textContent = customText;
          }
        }

        el.style.visibility = '';
      });
    }

    document.addEventListener('theme:variant:change', function (event) {
      applyCustomButtonText(event.target, event.detail && event.detail.variant);
    });

    document.addEventListener('DOMContentLoaded', function () {
      applyCustomButtonText(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      applyCustomButtonText(event.target);
    });
  })();



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
